import { Box, Button, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

// Original class: IssueButtonRoot
const StyledIssueButtonRoot = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    backgroundColor: '#ffffff',
    padding: theme.spacing(2.5, 2.5, 5),
    width: '100%',
    height: 'fit-content',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
    '&:focus': {
      backgroundColor: '#ffffff',
    },
  },
}));
// Original class: issueProject
const StyledIssueProject = styled(Box)(theme => ({
  wordBreak: 'break-all',
}));
const SpreadsheetMobileIssueButton = ({
  projectIssue,
  timeTypes,
  timeType,
  query,
  setQuery,
}) => {
  const handleOpenDetailIssue = useCallback(() => {
    setQuery({ issue: projectIssue.issueUniqueId });
  }, [projectIssue.issueUniqueId, setQuery]);

  return (
    <StyledIssueButtonRoot disableRipple onClick={handleOpenDetailIssue}>
      <Grid container direction='column'>
        <StyledIssueProject
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography
            variant='h4'
            align='left'
            sx={{
              fontWeight: 600,
            }}
          >
            {projectIssue.projectName}
          </Typography>
        </StyledIssueProject>
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography
            variant='h5'
            align='left'
            sx={{
              color: '#111322',
            }}
          >
            <FormattedMessage id='spreadsheet_table_issues' />:
          </Typography>
          <Typography variant='h4' align='left'>
            {projectIssue.issueName}
          </Typography>
        </Box>
        <Box>
          <Typography variant='h5' align='left'>
            <FormattedMessage id='spreadsheet_week_sum' />:
          </Typography>
          <Typography variant='h4' align='left'>
            {timeType === timeTypes.MAIN_HOURS
              ? projectIssue.totalNormalHours
              : projectIssue.totalOvertimeHours}{' '}
            ч
          </Typography>
        </Box>
      </Grid>
    </StyledIssueButtonRoot>
  );
};

export default SpreadsheetMobileIssueButton;
